export const AUDIENCE_OPTIONS = [
  {
    value: "guests",
    label: "Guests only",
    hint: "Anyone not signed in. The safe default — a first-order discount shown to a regular is money given away.",
  },
  {
    value: "customers",
    label: "Signed-in customers only",
    hint: "For win-back and loyalty campaigns aimed at people who already have an account.",
  },
  {
    value: "all",
    label: "Everyone",
    hint: "Guests and signed-in customers alike. Use for announcements, not for first-order discounts.",
  },
];

export const SURFACE_OPTIONS = [
  { value: "both", label: "Both (App + Web)" },
  { value: "web", label: "Web only" },
  { value: "app", label: "App only" },
];

// The list filter is not the same question as the form field. Filtering for
// "web" also returns popups set to "both", because those do run on web —
// reusing the form's "Web only" label there would describe the result wrongly.
export const SURFACE_FILTER_OPTIONS = [
  { value: "web", label: "Runs on web" },
  { value: "app", label: "Runs on app" },
];

export const AUDIENCE_VALUES = AUDIENCE_OPTIONS.map((o) => o.value);
export const SURFACE_VALUES = SURFACE_OPTIONS.map((o) => o.value);

// Mirrors MAX_POPUP_DELAY_SECONDS / MAX_POPUP_FREQUENCY_DAYS in the backend
// validator. Kept in sync by hand — the point of repeating them here is to
// catch a typo in the form instead of round-tripping it to a 400.
export const MAX_DELAY_SECONDS = 60;
export const MAX_FREQUENCY_DAYS = 365;

export const S3_POPUPS_FOLDER = "popups";

// Same whitelist as banners: SVG is excluded because a popup renders on the
// public storefront and an SVG can carry a <script>.
export const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "image/avif",
];

export const ALLOWED_IMAGE_ACCEPT = ALLOWED_IMAGE_TYPES.join(",");

export const audienceLabel = (value) =>
  AUDIENCE_OPTIONS.find((o) => o.value === value)?.label || value || "—";
